import { Component, OnInit, Input, Optional, Inject, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from '../../../../shared/sharedServices/loader.service';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { UploadAdditionalDocumentsService } from '../../upload-additional-documents/services/upload-additional-documents.service';
import { decrypt } from '../../../../../../src/app/utilities/utilityFunctions';
import { NgForm } from '@angular/forms';
import { PucaDataService } from '../../../../../../src/app/views/pages/puca/services/puca-data.service';
import { CommonHelper } from '../../../../../../src/app/core/_config/common.helper';
import { HecResponse } from '../../../../../../src/app/shared/shared-interfaces/hecResponse';

@Component({
	selector: 'kt-comments-list',
	templateUrl: './comments-list.component.html',
	styleUrls: ['./comments-list.component.css']
})
export class CommentsListComponent implements OnInit {
	public commentsList: Array<any>;
	public loader: boolean;
	@Input() appId: number;
	@Input() btnCancelText: string = 'Cancel';
	public comments: string;
	profile: any;
	@ViewChild('commentForm', { static: false }) commentForm: NgForm;
	pucaApplication: any;
	currentDocumentList = [];
	constructor(private loaderService: LoaderService,
		private dialogRef: MatDialogRef<CommentsListComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		private dataService: PucaDataService,
		private sharedService: SharedService,
		private uploadAdditionalService: UploadAdditionalDocumentsService,
		private cdr: ChangeDetectorRef) {

		this.profile = JSON.parse(decrypt(localStorage.getItem('esp-profile-details')));
	}

	ngOnInit() {
		this.getDasComments(this.data.appId)
		this.pucaApplication = this.data.pucaApplication;
		this.getDocumentListService()
	}

	public async getDasComments(appId): Promise<any> {
		try {
			this.loader = true;
			this.loaderService.setValue(this.loader)
			const res = await this.uploadAdditionalService.getDasComments(appId).toPromise()
			if (res.code == 0) {
				this.commentsList = [];
				res.result.forEach(element => {
					if (!element.degreeId) {
						this.commentsList.push(element);
					}
				});

				this.loader = false;
				this.loaderService.setValue(this.loader)
			} else {
			}
		} catch (err) {
			this.loader = false;
			this.loaderService.setValue(this.loader)
		}
	}

	public getDate(date): void {
		return this.sharedService.getDate(date);
	}

	public decline() {
		this.dialogRef.close(false);
	}

	public sendComment() {
		this.commentsList.push({
			'userName': this.profile.fullName,
			'commentsDate': Date.now(),
			'comments': this.commentForm.value.comment
		});
		const payload = {
			"data": {
				"applicationId": this.dataService.applicationId,
				"comments": this.commentForm.value.comment,
				"commentsDate": Date.now(),
				"userName": this.profile.fullName,
				"userNameType": this.dataService.isAdmin ? "AD" : ""
			}
		}
		this.postComments(payload)
	}

	public accept() {
		this.dialogRef.close(true);
	}

	public dismiss(type) {
		this.dialogRef.close(false);
	}

	private async postComments(payload) {
		const res: any = await this.sharedService.postComments(payload).toPromise();
		 this.getDasComments(this.data.appId);
		this.commentForm.reset();
	}


	public downloadDocument(file, index) {
		if (file.documentId) {
			let payload = {
				data: {
					documentId: file.documentId,
					acronym: 'PUCA'
				}
			}
			this.sharedService.getAttachmentByDocumentId(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.saveFile(res.data.content, file, res.data.path.toLowerCase().split('.').pop())
					}
				}
			)
		}
	}

	private saveFile(base64, fileData, fileType) {
		const base_64 = base64.substring(base64.indexOf(',') + 1);
		const contentType = fileType;
		const fileName = fileData.fileName ? fileData.fileName : fileData.title;
		const fileExt = '.' + contentType.substring(contentType.indexOf('/') + 1);

		const blob = CommonHelper.base64toBlob(base_64, contentType);
		const blobUrl = URL.createObjectURL(blob);

		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(blob, fileName + fileExt);
		}
		else {
			let a = document.createElement('a');
			a.href = blobUrl;
			a.download = fileName + fileExt;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		}
	}


	public deleteDocument(file, index) {

		let payload = {
			data: {
				documentId: file.documentId,
				acronym: 'PUCA'
			}
		}
		this.loaderService.setValue(true)
		this.sharedService.deleteDocument(payload).subscribe(
			(res: HecResponse) => {
				this.loaderService.setValue(false);
				this.getCurrentDocumentList()
			}
		)
	}


	private getCurrentDocumentList(): void {
		let payload = {
			data: {
				applicationId: +this.pucaApplication.applicationId,
				processAcronym: (this.pucaApplication.acronym) ? this.pucaApplication.acronym : 'PUCA',
			},
		};
		this.getDocumentListService()
	}

	private async getDocumentListService() {
		try {
			const pucaApplication = (this.pucaApplication && this.pucaApplication.pucaApplicationDto) ? this.pucaApplication.pucaApplicationDto : null
			const acronym = (pucaApplication && pucaApplication.acronym)? pucaApplication.acronym : 'PUCA';
			const id = (pucaApplication && pucaApplication.id) ? pucaApplication.id : null;
			const res: any = await this.sharedService.getDocumentList(acronym,id).toPromise();
			if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
				this.currentDocumentList = await res.data.filter(x=> x.addedBy == "ADMIN")
				this.cdr.detectChanges();
			}
			else if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.NO_DATA_FOUND) {
				this.currentDocumentList = []
				this.cdr.detectChanges()
			}
			else {
				this.currentDocumentList = []
				this.cdr.detectChanges();
			}
		}
		catch (error) {
			this.currentDocumentList = [];
			this.cdr.detectChanges()
			if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
				this.sharedService.showError(HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_WENT_WRONG, 'OK', 'error-snackbar');
			}
		}

	}

}
